import { makeAutoObservable } from 'mobx';

export class ReelStore {
  canStop = true;

  isForceStop = false;

  responseReady = false;

  rotating = false;

  stopComplete = false;

  canRotate = true;

  reelInitComplete = false;

  responseData = 0;

  stopCalled = false;

  isInBonusScene = false;

  firstLoop = false;

  stretchStopCalled = false;

  canStretch = false;

  isZeusDrop = false;

  constructor() {
    makeAutoObservable(this);
  }

  setCanStop(v) {
    this.canStop = v;
  }

  setIsZeusDrop(v) {
    this.isZeusDrop = v;
  }

  setCanStretch(v) {
    this.canStretch = v;
  }

  setFirstLoop(v) {
    this.firstLoop = v;
  }

  setStretchStopCalled(v) {
    this.stretchStopCalled = v;
  }

  setStopCalled(v) {
    this.stopCalled = v;
  }

  setResponseData(v) {
    this.responseData = v;
  }

  setIsForceStop(v) {
    this.isForceStop = v;
  }

  setResponseReady(v) {
    this.responseReady = v;
  }

  setIsInBonusScene(v) {
    this.isInBonusScene = v;
  }

  setRotating(v) {
    this.rotating = v;
  }

  setStopComplete(v) {
    this.stopComplete = v;
  }

  setCanRotate(v) {
    this.canRotate = v;
  }

  setReelInitComplete(v) {
    this.reelInitComplete = v;
  }

  resetWhenReelStop() {
    this.setStopCalled(false);
    this.setStopComplete(false);
    this.setResponseReady(false);
    this.setIsForceStop(false);
    this.setCanStop(false);
    this.setRotating(false);
    if (this.isInBonusScene) {
      this.setCanStretch(false);
      this.setStretchStopCalled(false);
    }
  }
}
